import EventEmitter from 'eventemitter3'

const bankruptRechargeEvents = new EventEmitter()

export default bankruptRechargeEvents
